import { Dialog, DialogActions, DialogContent, DialogTitle, Fade, Grid, Grow, Link, Paper, Slider, Stack, Tooltip, Typography } from "@mui/material";
import PlayerSelect from "../../../components/selectors/PlayerSelect";
import LeaguesSelect from "../../../components/selectors/Competitive/LeagueSelect";
import YearSelect, { PhaseSelect, SplitSelect } from "../../../components/selectors/PeriodSelect";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel, { a11yProps } from "../../../components/tabs_switch/tabs_panel";
import MultipleMetricsSelect from "../../../components/selectors/Shared/MetricsSelect";
import PlayerChampions from "../../../components/datagrids/Competitive/PlayerChampions";
import PlayerMatchHistory from "../../../components/datagrids/Competitive/PlayerHistory";
import React, { useContext, useEffect, useState } from "react";
import global_context from "../../../static_vars";
import FarsightApi from "../../../ApiWrapper";
import Box from "@mui/material/Box";
import dayjs, { Dayjs } from "dayjs";
import PlayerPresentation from "../../../components/visu_blocks/PlayerPresentation";
import StatRow from "../../../components/visu_blocks/StatRow";
import { SoloQPlayerStats } from "../../SoloQ/3_Players/16_PlayerDetailsSoloQ/SoloQPlayerDetails";
import { CompetitivePlayerStats } from "../../Competitive/3_Players/10_PlayersDetailsCompetitive/Players Details";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers";
import AgencySelect from "../../../components/selectors/Offseason/AgencySelect";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import { TeamSelect } from "../../../components/selectors/TeamSelect";
import { TimePicker } from "../../../components/selectors/Shared/DateSelect";
import DeleteIcon from "@mui/icons-material/Delete";
import PlayerEvolutionPerPatch from "../../../components/Charts/PlayerEvolutionPerPatch";
import AccountsSelect from "../../../components/selectors/SoloQ/AccountSelect";

export default function OffseasonPlayerAnalysis() {
    const context = useContext(global_context);
    context.state.current_leagues = [context.state.leagues[0]];

    const [state, setState] = useState({
        year: context.state.current_year,
        split: context.state.current_split,
        phase: context.state.current_phase,
        leagues: ["All-leagues"],
        champions: context.state.current_champions,
        player: context.state.current_player,
        metrics: context.state.current_metrics,
        tab: 0,
    });

    const [accounts, setAccounts] = useState([] as any[]);

    const handleLeagueChange = (event: any, newValue: string[]) => {
        setState({ ...state, leagues: newValue });
    };
    const handleMetricsChange = (event: any, newValue: string[]) => {
        setState({ ...state, metrics: newValue });
    };

    const handleChampionChange = (event: any, newValue: any) => {
        setState({ ...state, champions: newValue });
    };
    const handlePlayerChange = (event: any, newValue: string) => {
        setState({ ...state, player: newValue });
    };
    const handleTabChange = (event: any, newValue: number) => {
        setState({
            ...state,
            tab: newValue,
        });
    };

    const handleYearChange = (event: any, newValue: number) => {
        setState({ ...state, year: newValue });
    };

    const handleSplitChange = (event: any) => {
        setState({ ...state, split: event.target.value });
    };

    const handlePhaseChange = (event: any) => {
        setState({ ...state, phase: event.target.value });
    };

    return (
        <Stack
            direction={"row"}
            sx={{
                ml: "1%",
                width: window.innerWidth - 50 + "px",
                height: window.innerHeight - 150 + "px",
            }}
        >
            <Stack direction={"column"} spacing={1} sx={{ m: 2, height: "100%", width: "100%" }}>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <Stack direction={"row"} alignItems={"space-evenly"} justifyContent={"flex-start"} alignSelf={"space-evenly"} spacing={1}>
                        {/*<PlayerSelect getValue={state.player} onChange={handlePlayerChange} />*/}
                        {/*<LeaguesSelect getValue={state.leagues} onChange={handleLeagueChange}/>*/}
                        <YearSelect value={state.year} onChange={handleYearChange} />
                        <SplitSelect value={state.split} onChange={handleSplitChange} />
                        <PhaseSelect value={state.phase} onChange={handlePhaseChange} />
                        {/*<MultipleChampionSelect getValue={state.champions} onChange={handleChampionChange}/>*/}
                    </Stack>
                </Grow>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <Tabs value={state.tab} aria-label="basic tabs example" onChange={handleTabChange}>
                        <Tab label="Resume" {...a11yProps(0)} />
                        <Tab label="Summary" {...a11yProps(1)} />
                        <Tab label="Competitive" {...a11yProps(2)} />
                        <Tab label="SoloQ Evolution" {...a11yProps(3)} />
                        {/*<Tab label="Edit Informations" {...a11yProps(4)} />*/}
                    </Tabs>
                </Grow>
                {/*{state.tab !== 0 ? <Stack direction={'row'} spacing={1} sx={{m: 1, height: '75px', width: '100%'}}>*/}
                {/*    <MultipleMetricsSelect getValue={state.metrics} onChange={handleMetricsChange} target={'competitive'}/>*/}
                {/*</Stack> : <></>}*/}
                <TabPanel value={state.tab} index={0}>
                    <Stack direction={"row"} sx={{ height: window.innerHeight - 250 + "px" }}>
                        <PlayerOffseasonOverview {...state} />
                    </Stack>
                </TabPanel>
                <TabPanel value={state.tab} index={1}>
                    <Grid sx={{ height: window.innerHeight - 250 + "px" }}></Grid>
                </TabPanel>
                <TabPanel value={state.tab} index={2}>
                    <Grid sx={{ height: window.innerHeight - 250 + "px" }}></Grid>
                </TabPanel>
                <TabPanel value={state.tab} index={3}>
                    <Grid sx={{ height: window.innerHeight - 250 + "px" }}>
                        <AccountsSelect player={state.player.player} value={accounts} onChange={(event: any, newValue: any) => setAccounts(newValue)} />
                        <PlayerEvolutionPerPatch player={state.player.player} year={state.year} groupby={"patch"} target={"soloq"} accounts={accounts.map((acc: any) => acc.account)} />
                    </Grid>
                </TabPanel>
            </Stack>
        </Stack>
    );
}

export function PlayerOffseasonOverview(props: any) {
    return (
        <Stack
            direction={"row"}
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "space-evenly",
            }}
        >
            {props.player ? <PlayerPresentation player={props.player.player} /> : <></>}
            <CompetitivePlayerStats {...props} target={"competitive"} player={props.player.player} />
            <SoloQPlayerStats player={props.player.player} year={2023} target={"soloq"} />
            <PlayerNotes player={props.player.player} />
        </Stack>
    );
}

function PlayerNotes(props: { player: string }) {
    const [notes, setNotes] = useState([] as any[]);

    useEffect(() => {
        setNotes([]);
        FarsightApi.get_request("GetPlayerNotes", props).then((data) => {
            setNotes(data);
        });
    }, [props.player]);

    function CreateNote() {
        FarsightApi.get_request("CreatePlayerNote", {
            player: props.player,
        }).then((data) => {
            setNotes(data);
        });
    }

    function DeleteNote(note: any) {
        FarsightApi.get_request("DeletePlayerNote", {
            id: note.id,
            player: props.player,
        }).then((data) => {
            setNotes(data);
        });
    }

    return (
        <Stack
            direction={"column"}
            sx={{
                minWidth: "400px",
                maxWidth: "500px",
                height: "100%",
                outline: "1px solid white",
                borderRadius: 2,
                justifyContent: "flex-start",
                alignItems: "center",
                padding: "5px",
            }}
            spacing={2}
        >
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 500 }}>
                <Paper
                    sx={{
                        width: "90%",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        display: "flex",
                    }}
                >
                    {`Notes on ${props.player}`}
                    <Button onClick={CreateNote}>Add Note</Button>
                </Paper>
            </Grow>
            {notes.map((note: any, index: number) => {
                return <PlayerNote note={note} index={index} deleteNote={DeleteNote} />;
            })}
        </Stack>
    );
}

function PlayerNote(props: { note: any; index: number; deleteNote: any }) {
    const { note } = props;
    const [editBox, setEditBox] = useState(false);
    const [noteContent, setNoteContent] = useState(props.note.content);

    return (
        <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: (props.index + 1) * 500 }}>
            <Paper sx={{ maxWidth: "90%", borderRadius: 2, padding: "5px" }}>
                <EditNote
                    note={note}
                    close={() => setEditBox(false)}
                    open={editBox}
                    setNoteContent={(new_content: string) => {
                        setNoteContent(new_content);
                    }}
                />
                <Stack
                    direction={"row"}
                    sx={{
                        width: "100%",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                    }}
                >
                    <Typography>{note.author_id}</Typography>
                    <Typography>{note.author_organization}</Typography>
                    <Button
                        disabled={FarsightApi.get_user_infos().username !== note.author_id}
                        onClick={() => {
                            setEditBox(!editBox);
                        }}
                    >
                        <EditIcon />
                    </Button>
                    <Button disabled={FarsightApi.get_user_infos().username !== note.author_id} onClick={() => props.deleteNote(props.note)}>
                        <DeleteIcon />
                    </Button>
                </Stack>
                <Typography sx={{ width: "100%" }}>{noteContent}</Typography>
            </Paper>
        </Grow>
    );
}

function EditNote(props: { open: boolean; note: any; close: any; setNoteContent: any }) {
    const [content, setContent] = useState(props.note.content as string);

    function handleClose() {
        FarsightApi.post_request("EditPlayerNote", { id: props.note.id }, { content: content }).then((note) => {
            props.setNoteContent(content);
        });
        props.close();
        return true;
    }

    // @ts-ignore
    return (
        <Dialog open={props.open} onClose={handleClose}>
            <DialogTitle>Add Session</DialogTitle>
            <DialogContent sx={{ height: "500px" }}>
                <Box sx={{ padding: "20px", width: "500px" }}>
                    <TextField label="Note" variant="filled" fullWidth multiline rows={15} value={content} onChange={(event: any) => setContent(event.target.value)} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.close}>Cancel</Button>
                <Button onClick={handleClose}>Edit Note</Button>
            </DialogActions>
        </Dialog>
    );
}
